/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, imageTypes, centerAbsolutely, convertHexToRGB, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : ADs : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	ads: {
        '& .placements': {
            display:'flex',
            justifyContent:'center',
            flexWrap: 'wrap',
    		'& .placement-location': {
    			marginBottom: pxToEm(20),
                opacity: '0',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationDelay: '.4s',
                '& .title': {
                    opacity: '0',
                    animationName: 'fadeInUp',
                    animationDuration: '.2s',
                    animationFillMode: 'forwards',
                    animationDelay: '.9s',
                    '& h3': {
                        color: theme.color.neutral.dark.swatch,
                        fontSize:pxToEm(15)
                    }
                },
    			'& .visual': {
    				'& .device': {
    					extend: imageTypes.graphic,
    					margin: `0 ${pxToEm(20)}`,
    					position: 'relative',
    					'& .embed-container': {
                            position: 'absolute',
                            '& .toggle': { 
                                fontSize: '65%',
                                margin: replacePXinStringWithEM('12px auto')
                            },
                            '& .embed': {
                                extend: imageTypes.graphic,
                                backgroundSize: 'cover',
                                borderRadius: pxToEm(6),
                                width: '100%',
                                position: 'relative'
                            },
                            '& .group': {
                                extend: centerAbsolutely,
                                width: '100%',
                                textAlign: 'center'
                            },
                            '& .ad': {
                                borderRadius: pxToEm(6),
                                transition: 'background .2s linear 0s',
                                width: '100%',
                                cursor:'pointer',
                                '&.inline': {
                                    animationName: 'jello',
                                    animationDuration: '.7s',
                                    animationFillMode: 'forwards',
                                    animationDelay: '1.1s',
                                    background: theme.color.neutral.light.swatch,
                                    position: 'relative',
                                    '& .desc': { 
                                        fontSize: pxToEm(16), 
                                        color: theme.color.supporting.dark.swatch 
                                    },
                                    '&.on': { 
                                        background: theme.color.primary.light.swatch 
                                    }
                                },
                                '&.overlay': {
                                    opacity: '0',
                                    animationName: 'fadeIn',
                                    animationDuration: '.3s',
                                    animationFillMode: 'forwards',
                                    animationDelay: '1.7s',
                                    background: convertHexToRGB(theme.color.dark.dark.swatch, 60),
                                    extend: centerAbsolutely,
                                    width: '95%',
                                    height: '95%',
                                    '& .desc': {
                                        fontSize: pxToEm(16), 
                                        color: theme.color.light.light.swatch 
                                    },
                                    '& .note': {
                                        fontSize: pxToEm(16), 
                                        color: theme.color.neutral.medium.swatch 
                                    },
                                    '&.on': { 
                                        background: convertHexToRGB(theme.color.dark.dark.swatch, 100)
                                    }
                                }
                            }
                        }
    				}
    			}
            }
		}
	},

    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [`@media only screen and (min-width:${pxToEm(910)}) and (max-width:${pxToEm(1070)})`]: {
        ads: {
            '& .placement-location': {
                fontSize: '85%'
            }
        }
    },
    [`@media only screen and (min-width:${pxToEm(700)}) and (max-width:${pxToEm(910)})`]: {
        ads: {
            '& .placement-location': {
                fontSize: '75%'
            }
        }
    },
    [mediaQuery.thinnest]: { 
        ads: {
            '& .visual': {
                fontSize: '70%'
            }
        }
    }
});